export default __webpack_public_path__ + "static/media/Interspacechat-logo.11923c6e.svg";